/**
 * Phase 0.5 Component F — imperative variant of useViewProjection.
 *
 * `useResolveAction(resource, action)` returns
 *   `{ allowed, blocked, masked, viewMode, isLoading }`
 * for callers that need to gate a non-button surface — form submission,
 * keyboard shortcut, navigation guard. Compose this in custom logic
 * paths; otherwise presourceer `<ActionGate action="…">`.
 */ import { useMemo } from 'react';
import { useViewProjection } from './useViewProjection';
export function useResolveAction(resource, action) {
    const { data, isLoading } = useViewProjection(resource, {
        action
    });
    return useMemo(()=>{
        if (!data) {
            return {
                allowed: false,
                blocked: true,
                masked: false,
                viewMode: 'no_view',
                isLoading
            };
        }
        const blocked = data.actionBlocked.includes(action);
        return {
            allowed: data.decision === 'allow' && !blocked,
            blocked,
            masked: data.viewMode === 'masked',
            viewMode: data.viewMode,
            isLoading,
            policy: data
        };
    }, [
        data,
        isLoading,
        action
    ]);
}
